<template>
  <div class="pages">
    <!-- 头部组件 -->
    <AppHeader v-if="$route.path !== '/home'" />
    <!-- 内容容器 -->
    <div class="app-body">
      <!-- 二级路由 -->
      <router-view />
    </div>
    <SideBar />
    <!-- 底部组件 -->
    <AppFooter />
  </div>
</template>
<script setup>
import AppFooter from '@/components/AppFooter'
import AppHeader from '@/components/AppHeader'
import SideBar from '@/components/SideBar'
import { useRoute } from 'vue-router'
const $route = useRoute()
// import { computed } from 'vue';
// const $router = useRouter();
// const { options } = $router;
// const routeNames = options.routes.map(item => item.name);
// const isMainRoute = computed(() =>
//   routeNames.includes($router.currentRoute._value.name)
// );

// console.log(
//   'options:',
//   options.routes,
//   $router.currentRoute._value.name,
//   isMainRoute.value
// );
</script>
<style scoped lang="scss">
.pages {
  position: relative;
  width: 100%;
  height: 100%;
}

.app-body {
  min-height: 600px;
  // height: calc(100vh - 80px);
}
</style>
